import { FileModel, Folder, FolderViewModel, Result, ResultGroup, ResultModule } from '@ca/core/models';
import { FolderPathInfo } from 'src/app/core/models/folder-path-info.model';

export function mapAllResultsToFolders(results: Result[]): FolderViewModel[] {
    return results.map((res: Result) => mapResultToFolder(res));
}

export function mapAllGroupResultsToFolders(results: ResultGroup[]): FolderViewModel[] {
    return results.map((res: ResultGroup) => mapGroupResultToFolder(res));
}

export function mapFolderToFolderViewModel(folder: Folder): FolderViewModel {
    return {
        id: folder.id,
        name: folder.name,
        files: folder.files as FileModel[],
        subfolders: [],
    };
}

export function mapFolderPathInfoToFolderViewModel(folderPathInfo: FolderPathInfo): FolderViewModel {
    return {
        id: folderPathInfo.id,
        name: folderPathInfo.name,
        files: [],
        subfolders: [],
    };
}

function mapGroupResultToFolder(resultGroup: ResultGroup): FolderViewModel {
    if (resultGroup.workflowResults!.length === 1) {
        return mapResultToFolder(resultGroup.workflowResults![0]);
    } else {
        const folder: FolderViewModel = {
            id: resultGroup.batchCorrelationId?.toString(),
            name: resultGroup.title || '',
            subfolders: resultGroup.workflowResults!.map((res: Result) => mapResultToFolder(res)),
            files: [],
        };
        return folder;
    }
}

function mapResultToFolder(result: Result): FolderViewModel {
    const folder: FolderViewModel = {
        id: result.id,
        name: result.title || '',
        subfolders: mapModulesToFolders(result.modules),
        files: [],
    };

    return folder;
}

function mapModulesToFolders(res?: ResultModule[]): FolderViewModel[] {
    let folders: FolderViewModel[] = [];
    if (res != null) {
        folders = res.map((module: ResultModule) => mapModuleToFolder(module));
    }

    folders = sortFoldersBySortOrder(folders);

    return folders;
}

function sortFoldersBySortOrder(folders: FolderViewModel[]): FolderViewModel[] {
    // avoid having references
    folders = [...folders];

    folders = folders.sort((folder1: FolderViewModel, folder2: FolderViewModel) => {
        const folder1SortOrder = folder1.sortOrder || 99;
        const folder2SortOrder = folder2.sortOrder || 99;

        return folder1SortOrder - folder2SortOrder;
    });

    return folders;
}

function mapModuleToFolder(mod: ResultModule): FolderViewModel {
    const folder: FolderViewModel = {
        id: mod.id,
        name: getModuleStepName(mod),
        subfolders: [],
        files: mod.resultFiles || [],
        sortOrder: mod.stepId || 0,
    };

    return folder;
}

function getModuleStepName(mod: ResultModule): string {
    const stepId = mod.stepId || '0';
    return 'Step ' + stepId + ' | ' + mod.title;
}
